import { Button, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { TallymanV2ViewStore } from '@planning/rt-stores/tallyman/TallymanV2ViewStore'
import { useTranslate } from '@tolgee/react'
import { SearchIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

interface Props {
  store: TallymanV2ViewStore
  onSearchClick: () => void
}

export const ContainerSearchBox: FC<Props> = observer(({ store, onSearchClick }) => {
  const { t } = useTranslate()

  const { vesselTallyStore } = store
  const {
    selectedOperation: operation,
    totalDischargeOrders,
    totalLoadOrders,
    totalDischargeConfirmed,
    totalLoadConfirmed,
  } = vesselTallyStore

  if (!operation) return <></>

  const checkedItems =
    (operation === 'Discharge' ? totalDischargeConfirmed : totalLoadConfirmed) || 0

  const totalOrders = (operation === 'Discharge' ? totalDischargeOrders : totalLoadOrders) || 0

  const pendingReportOrder = vesselTallyStore.reportNotificationStore.request ? 1 : 0

  return (
    <Box
      sx={{
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Typography variant='h3'>{`${checkedItems + pendingReportOrder}/${
        totalOrders + pendingReportOrder
      }`}</Typography>
      <Typography>
        {t('containers', 'Containers')} {t(operation, operation)}
      </Typography>
      <Button
        data-cy='search-container'
        variant='contained'
        size='large'
        startIcon={<SearchIcon />}
        sx={{ width: '100%', mt: '1rem' }}
        onClick={onSearchClick}
        disabled={!vesselTallyStore.isSelectedVisitInOperation}
      >
        {t('searchContainer', 'Search container')}
      </Button>
    </Box>
  )
})
